import { useState } from "react";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import Icon from "../components/icons";
import "dayjs/locale/it";

const CalendarSearch = ({ data, onChange, value = [] }) => {
  const [searchParams] = useSearchParams();
  const [enableDays, setEnableDays] = useState(
    !!searchParams.get("dt_r")?.length
  );

  return (
    <div
      className={classNames(
        "d-flex justify-content-center calendar",
        !enableDays && "calendar--disabled"
      )}
    >
      <div>
        <div className="calendar__month d-flex flex-column flex-lg-row gap-1 mt-3">
          {data?.map((row) => (
            <div key={row.label} className="d-flex flex-column mb-3">
              <div>{row.label}</div>
              <div className="d-flex flex-wrap flex-row gap-1">
                {row.days.map((item) => {
                  const dayNumber = dayjs(item.daycode, "YYYYMMDD").format("D");
                  const dayName = dayjs(item.daycode, "YYYYMMDD")
                    .locale("it")
                    .format("ddd");
                  return (
                    <button
                      key={item.daycode}
                      className={classNames(
                        "calendar__day",
                        value.includes(item.searchcode) &&
                          enableDays &&
                          "calendar__day--active"
                      )}
                      title={dayjs(item.daycode, "YYYYMMDD")
                        .locale("it")
                        .format("dddd, D MMMM")}
                      disabled={!enableDays}
                      onClick={() => {
                        enableDays &&
                          onChange(
                            value.includes(item.searchcode)
                              ? value.filter((e) => e !== item.searchcode)
                              : value.concat([item.searchcode])
                          );
                      }}
                    >
                      {" "}
                      <span className="calendar__number">{dayNumber}</span>
                      <span
                        className={classNames(
                          "calendar__name",
                          (dayName === "dom" || dayName === "sab") &&
                            "calendar__name--weekend"
                        )}
                      >
                        {dayName}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="float-none float-lg-end">
          <button
            type="button"
            className="btn-all-day"
            title={enableDays ? "Scegli i giorni" : "Visualizza tutti i giorni"}
            onClick={() => {
              onChange([]);
              setEnableDays(!enableDays);
            }}
          >
            <span className="btn-all-day-label">
              {enableDays ? "Scegli i giorni" : "Visualizza tutti i giorni"}
            </span>
            &#160;
            <Icon name="check" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CalendarSearch;
